import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			fill: "#000",
			width: 39,
			height: 27.444,
			x: .5,
			y: 4.056,
			stroke: "#000",
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#fff",
			width: 39,
			height: 27.444,
			x: .5,
			y: .5,
			stroke: "#000",
			rx: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 11.5h25m-25 8h25",
			stroke: "#000",
			strokeLinecap: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2240%22%20height%3D%2232%22%20viewBox%3D%220%200%2040%2032%22%3E%3Crect%20fill%3D%22%23000%22%20width%3D%2239%22%20height%3D%2227.444%22%20x%3D%22.5%22%20y%3D%224.056%22%20stroke%3D%22%23000%22%20rx%3D%221.5%22%2F%3E%3Crect%20fill%3D%22%23fff%22%20width%3D%2239%22%20height%3D%2227.444%22%20x%3D%22.5%22%20y%3D%22.5%22%20stroke%3D%22%23000%22%20rx%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M7.5%2011.5h25m-25%208h25%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%2F%3E%3C%2Fsvg%3E";
